import axios from '@/store/axios.factory'

class GRPRService {
  consultaCdBarras(cdBarras) {
    return axios.get(`/v1/grpr/consulta/cdbarras/${cdBarras}`)
  }

  emissao(cdCategoria, cdArrecadacao, cdUga) {
    let codArrecadacao = (cdArrecadacao) ? `&cdArrecadacao=${cdArrecadacao}` : ''

    return axios.get(`/v1/grpr/emissao?cdCategoria=${cdCategoria}${codArrecadacao}&cdUga=${cdUga}`)
  }

  passo2(p) {
    return axios.post(`/v1/grpr/emissao/passo2`, p)
  }

  pesquisarParcelamento ({ numeroParcelamento, identificacao, identificacaoValor, diaCalculo, tpParcela, parcelas }) {
    let query = '?'
    query += numeroParcelamento ? `&numeroParcelamento=${numeroParcelamento}` : ''
    query += identificacao ? `&identificacao=${identificacao}` : ''
    query += identificacaoValor ? `&identificacaoValor=${identificacaoValor}` : ''
    query += diaCalculo ? `&diaCalculo=${diaCalculo}` : ''
    query += tpParcela ? `&tpParcela=${tpParcela}` : ''
    query += parcelas ? `&parcelas=${parcelas}` : ''

    return axios.get(`/v1/grpr/parcelamento${query}`)
  }
}

export const grprService = new GRPRService()
